var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 header",attrs:{"id":"headerCalendarTitle"}},[_c('div',{staticStyle:{"margin":"0px auto"}},[_c('img',{directives:[{name:"openlog",rawName:"v-openlog"}],staticClass:"client_logo",attrs:{"src":_vm.Logo}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }